module.exports = __webpack_public_path__ + "img/0A5A1301A-min.00f11788.jpg";